import { render, staticRenderFns } from "./app.vue?vue&type=template&id=8555a928&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "mathlive/dist/mathlive.core.css?vue&type=style&index=0&lang=css&"
import style1 from "mathlive/dist/mathlive.css?vue&type=style&index=1&lang=css&"
import style2 from "video.js/dist/video-js.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports